export const EVENT_CONFIG = {
  webUrl: process.env.REACT_APP_WEB_URL,
};
